import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import ConversationFactory from "../../Entity/Factories/ConversationFactory";

export default function* conversationList(action: ActionInterface): any {
  try {
    const res = yield call(Http.get, "conversations");

    const conversations = res.data.map(conversation => {
      return ConversationFactory.create(conversation);
    });

    yield put({
      type: Constants.GLOBAL_CONVERSATIONS_SAVE_LIST_SUCCESS,
      payload: {
        conversations: conversations
      }
    });

  } catch (err) {
    // should signout user if entity could not be loaded
    yield put({
      type: Constants.PAGE_SIGNOUT_START
    });
    
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchConversationList() {
  yield takeEvery(Constants.GLOBAL_CONVERSATIONS_SAVE_LIST, conversationList);
}
